import styled from 'styled-components';

import {
  grey10,
  grey6,
  grey3,
  orange2,
  orange4,
} from 'approot/shared/styles/colours.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { rem } from 'approot/shared/style';
import { spacing16, spacing4 } from 'approot/shared/styles/spacing.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';

export const StarButtonsContainer = styled.div`
  ${flexCentreAlignCss}
  gap: ${rem(8)};
  margin: 0 ${rem(spacing16)};
`;

export const StarButton = styled.button<{
  $filled: boolean;
}>`
  border-radius: ${rem(borderRadius8)};
  background: ${props => (props.$filled ? orange2 : grey3)};
  border: none;
  cursor: pointer;
  position: relative;
  padding: ${rem(spacing4)};

  &:hover {
    outline: 2px solid ${orange4};
  }

  &:focus {
    outline: 2px solid ${grey10};
  }
`;

export const StarIconBox = styled.div<{
  $filled: boolean;
}>`
  color: ${props => (props.$filled ? orange2 : grey6)};
  svg {
    fill: ${props => (props.$filled ? orange4 : 'none')};
  }
`;
